var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportGradient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4314_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0C8.09696 0 3.29407 4.80289 3.29407 10.7059V20.5881C3.29407 21.9506 4.40234 23.0589 5.76462 23.0589C7.12711 23.0589 8.23538 21.9506 8.23538 20.5881V12.353C8.23538 10.9907 7.12711 9.88242 5.76462 9.88242C5.48734 9.88242 5.22501 9.9386 4.97571 10.0232C5.32712 5.34677 9.23599 1.64703 14 1.64703C18.7614 1.64703 22.6693 5.34335 23.0239 10.0166C22.7761 9.93176 22.5122 9.88242 22.2354 9.88242C20.8729 9.88242 19.7646 10.9907 19.7646 12.353V20.5881C19.7646 21.9506 20.8729 23.0589 22.2354 23.0589C22.5255 23.0589 22.8 22.9995 23.0589 22.9072V23.8824C23.0589 24.3368 22.6889 24.7059 22.2354 24.7059H16.3189C15.9777 23.7493 15.0722 23.0589 14 23.0589C12.6377 23.0589 11.5295 24.1672 11.5295 25.5294C11.5295 26.8917 12.6377 28 14 28C15.0722 28 15.9777 27.3094 16.3189 26.353H22.2354C23.5977 26.353 24.7059 25.2447 24.7059 23.8824C24.7059 18.9289 24.7059 15.6648 24.7059 10.7059C24.7059 4.80289 19.903 0 14 0Z",
    fill: "url(#paint0_linear_4314_157)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.353 11.681V21.2599C27.3094 20.9189 28 20.0134 28 18.941V13.9999C28 12.9277 27.3094 12.0222 26.353 11.681Z",
    fill: "url(#paint1_linear_4314_157)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.9999V18.941C0 20.0134 0.690643 20.9189 1.64703 21.2599V11.681C0.690643 12.0222 0 12.9277 0 13.9999Z",
    fill: "url(#paint2_linear_4314_157)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4314_157",
    x1: -4.70556,
    y1: 58.1,
    x2: -31.076,
    y2: 35.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4314_157",
    x1: -4.70556,
    y1: 58.1,
    x2: -31.076,
    y2: 35.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4314_157",
    x1: -4.70556,
    y1: 58.1,
    x2: -31.076,
    y2: 35.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4314_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportGradient);
export default __webpack_public_path__ + "static/media/support_gradient.2dcbffd884e6bc70760afb6e106224e6.svg";
export { ForwardRef as ReactComponent };